import './../Filter/Filter.scss';
import Component from './FirmListFilter.js';
export default Component;